import { render } from "./NFTCard.vue?vue&type=template&id=4b273b8b&scoped=true"
import script from "./NFTCard.vue?vue&type=script&lang=js"
export * from "./NFTCard.vue?vue&type=script&lang=js"

import "./NFTCard.vue?vue&type=style&index=0&id=4b273b8b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b273b8b"]])

export default __exports__